<p-calendar
  [formControl]="formControl"
  [monthNavigator]="monthNavigator"
  [yearNavigator]="yearNavigator"
  [yearRange]="yearRange"
  [placeholder]="placeholder"
  [dateFormat]="dateFormat"
  [dataType]="dataType"
  [showIcon]="true"
  showButtonBar="true"
  appendTo="body" 
  (onSelect)="onDateSelect($event)"
></p-calendar>
